<template>
    <editor-content class="editor__content edt" :editor="editor" />
</template>

<script>
    // Import the editor
    import {Editor, EditorContent} from 'tiptap'
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        HorizontalRule,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History
    } from 'tiptap-extensions'

    export default {
        name: "ContentDisplayer",
        components: {
            EditorContent,
        },
        watch: {
            current: {
                handler (val, oldVal) {
                    this.setContent(val)
                }
            }
        },
        props: {
            current: {
                type: String,
            }
        },
        data() {
            return {
                editor: null,
                default: '{"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":"Vul "},{"type":"text","marks":[{"type":"italic"}],"text":"hier"},{"type":"text","text":" een "},{"type":"text","marks":[{"type":"bold"}],"text":"opgemaakte"},{"type":"text","text":" beschrijving in."}]}]}'
            }
        },
        mounted() {
            this.editor = new Editor({
                extensions: [
                    new Blockquote(),
                    new BulletList(),
                    new CodeBlock(),
                    new HardBreak(),
                    new Heading({levels: [1, 2, 3]}),
                    new HorizontalRule(),
                    new ListItem(),
                    new OrderedList(),
                    new TodoItem(),
                    new TodoList(),
                    new Link({
                        openOnClick: true, // Makes links clickable
                        HTMLAttributes: {
                            target: '_blank', // Opens links in a new tab
                            class: 'editor-link',
                        },
                    }),
                    new Bold(),
                    new Code(),
                    new Italic(),
                    new Strike(),
                    new Underline(),
                    new History(),
                ],
                content: this.getCurrent,
                editable: false
            })
            this.editor.setContent(JSON.parse(this.getCurrent))
        },
        computed: {
            getCurrent() {
                if(!this.current) {
                    return this.default
                }
                return this.current
            }
        },
        beforeDestroy() {
            this.editor.destroy()
        },
        methods: {
            setContent(JSONString) {
                if(!JSONString) {
                    this.editor.setContent(JSON.parse(this.default));
                } else {
                    this.editor.setContent(JSON.parse(JSONString));
                }
            }
        }
    }
</script>

<style>
    .editor__content {
        padding: 0;
        margin: 0;
    }

    .editor__content ul li {
      list-style-type: circle;
    }
    .editor__content ol li {
      list-style-type: decimal;
    }
    .editor__content li p {
      margin-top: 0px;
    }

    .editor__content {
      line-height: 20px;
    }

    .editor__content p {
      margin-top: 10px;
    }

    .editor__content a {
        text-decoration: underline !important;
        color: #409EFF !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/content/ContentDisplayer.vue